module.exports = __webpack_public_path__ + "img/wheelchair.d9fe61a3.png";